import axios from "axios";

export type TUploadType = "JPEG" | "PNG" | "GIF" | "WEBP";

export interface IPresignedPost {
  url: string;
  key: string;
  fields: { name: string; value: string }[];
}

export const buildMediaUrl = (
  presigned: Pick<IPresignedPost, "url" | "key">,
): string => `${presigned.url}/${presigned.key}`;

export const uploadFileToS3 = async (
  presigned: IPresignedPost,
  file: File | Blob,
): Promise<void> => {
  const formData = new FormData();

  for (const field of presigned.fields) {
    formData.append(field.name, field.value ?? "");
  }
  formData.append("file", file);

  await axios.post(presigned.url, formData);
};
